import superagent from "superagent";

import { API_PREFIX } from "app/constants";
import to from "core/util/fetch/awaitToJs";
import { SignatureDto } from "serverApi/vehicleSubjectChange";

const uriPrefix = `${API_PREFIX}/vehicle-digi-sign`;

const checkDigisignEligibilityNoParams = async () => {
    return await to(superagent.get(`${uriPrefix}/eligibility`));
};

const checkDigisignEligibility = async (idChange: string) => {
    return await to(superagent.get(`${uriPrefix}/${idChange}/eligibility`));
};

const sign = async (idChange: string, body: SignatureDto) => {
    return await to(superagent.post(`${uriPrefix}/sign/${idChange}`).send(body).set("Content-Type", "application/json"));
};

const finalize = async (idChange: string, envelopeId: string) => {
    return await to(superagent.get(`${uriPrefix}/sign/${idChange}/finalize/${envelopeId}`));
};

export default {
    checkDigisignEligibilityNoParams,
    checkDigisignEligibility,
    sign,
    finalize,
};
